import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <>
    
      {/* Topbar */}
      <div className="topbar-three">
        <div className="container">
          <div className="row">
            <div className="col-10">
              <p className='brand-text'>Wall Street <span>Finz</span> : Unit of Wall Street Merchants Private Limited.</p>
            </div>
            
            <div className="col-2">
              <ul className="topbar-two-social-media">
                <li><a href="tel:+919911998997">+91 9911998997</a></li>
               
              </ul>
            </div> 
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="main-header main-header-four">
        <div className="container">
          <nav className="main-menu">
            <div className="main-menu-logo">
              <a href="/">
                <img alt="header-logo" src="/assets/images/logo.png" height={100} className="logo-normal"/>
                <img src="/assets/images/logo.png" className="logo-sticky" alt="logo"></img>
              </a>
            </div>
            <div className="main-menu-inner">
              <ul className="main-menu-list">
                <li className="menu-item-children"><a href="/">Home</a></li>
                <li className="menu-item-children">
                  <a href="/about">About</a>
                  {/* <i className="fa-solid fa-chevron-down"></i>
                  <ul>
                    <li><a href="/about">Who We Are</a></li>
                    <li><a href="/team">Meet The Team</a></li>
                  </ul> */}
                </li>
                <li className="menu-item-children">
                  <a href="/service">Services</a>
                  {/* <i className="fa-solid fa-chevron-down"></i> */}
                  {/* <ul>
                    <li><a href="/apply-for-home-loan">Home Loan</a></li>
                  </ul> */}
                </li>
                <li className="menu-item-children"><a href="/repay">Repay</a></li>
                <li className="menu-item-children"><a href="/contact">Contact Us</a></li>
                <li className="menu-item-children  apply-btn"><Link to="https://loan.wallstreetfinz.com">Apply Now</Link></li>
              </ul>
              <div className="header-right-end">
                <span className="line-1"></span>
                <span className="line-2"></span>
                <span className="line-3"></span>
              </div>
            </div>
            {/* <div className="main-menu-right">
              <a className="menu-phone" href="tel:+919880166275">
                <i className="flaticon-phone"></i> +91 9911998997
              </a>
            </div> */}
          </nav>
        </div>
      </header>

      {/* Mobile Nav Wrapper - Kept in Header for structural logic */}
      <div className="mobile-nav-wrapper">
        <div className="mobile-nav-overlay mobile-nav-toggler"></div>
        <div className="mobile-nav-content">
          <Link className="mobile-nav-close mobile-nav-toggler" to="#">
            <span></span><span></span>
          </Link>
          <div className="logo-box">
            <a href="/">
              <img alt="logo" src="/assets/images/logo.png" height={100} />
            </a>
          </div>
          <div className="mobile-nav-container">
            <ul className="mobile-menu-list">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/service">Service</a></li>
              <li><a href="/repay">Repay</a></li>
              <li><Link to="https://loan.wallstreetfinz.com">Apply-Now</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;